import * as React from 'react'
import {useState, useEffect} from 'react'
import getValueTrack from '../../../helpers/valueTrack/getValueTrack'
import {ValueTrack} from '../../../hooks/useValueTrackSaver'

const ValueTrackFields = () => {
    const [valueTracks, setValueTracks] = useState<Array<ValueTrack> | null>(null)

    useEffect(() => {
        setValueTracks(getValueTrack())
    }, [])

    return valueTracks ? (
        <>
            {valueTracks.map((valueTrackObject, index) => {
                return (
                    <React.Fragment key={index}>
                        <input
                            name={`value_tracks[${index}][campaign_id]`}
                            type="hidden"
                            value={valueTrackObject.campaignId || ''}
                        />
                        <input
                            name={`value_tracks[${index}][group_id]`}
                            type="hidden"
                            value={valueTrackObject.groupId || ''}
                        />
                        <input
                            name={`value_tracks[${index}][keyword]`}
                            type="hidden"
                            value={valueTrackObject.keyword || ''}
                        />
                        <input
                            name={`value_tracks[${index}][lead_id]`}
                            type="hidden"
                            value={valueTrackObject.platformData.id || ''}
                        />
                        <input
                            name={`value_tracks[${index}][platform]`}
                            type="hidden"
                            value={valueTrackObject.platformData.platform || ''}
                        />
                    </React.Fragment>
                )
            })}
        </>
    ) : null
}

export default ValueTrackFields
